import { mkTransportAccessibilityInfrastructure } from '../../../__stubs__/mocks/transportAccessibilityInfrastructure';
import { transformFutureRoads } from '../../../mappers/transformFutureRoads';
import { transformTransportAccessibilityInfrastructure } from '../../../mappers/transformTransportAccessibilityInfrastructure';
import { ITAInfrastructure, TRegularInfrastructureItem } from '../../../types/map';
import { getInfrastructureItems } from './getInfrastructureItems';

export async function getAndPrepareInfrastructureItems(
  newbuildingId: number,
  infrastructureTypes: boolean,
): Promise<{
  regularInfrastructure: TRegularInfrastructureItem[];
  transportAccessibilityInfrastructure?: ITAInfrastructure;
}> {
  if (!infrastructureTypes) {
    return {
      regularInfrastructure: [],
    };
  }

  const response = await getInfrastructureItems(newbuildingId);

  const futureInfrastructure = response.futureInfrastructure || [];
  const futureRoads = transformFutureRoads(response.futureRoads);

  // TODO: Убрать мок в CD-170031.
  const transportAccessibilityInfrastructureResponse =
    response.transportAccessibility || mkTransportAccessibilityInfrastructure();
  const transportAccessibilityInfrastructure = transformTransportAccessibilityInfrastructure(
    transportAccessibilityInfrastructureResponse as ITAInfrastructure,
  );

  return {
    regularInfrastructure: [...response.infrastructure, ...futureInfrastructure, ...futureRoads],
    transportAccessibilityInfrastructure,
  };
}
